import { Button, Header, Paragraph } from "@datagame/ui";
import { Dialog } from "@headlessui/react";
import { useTranslation } from "react-i18next";

import { Game, RankifierConfiguration } from "../../../../gql/graphql";
import { isQuickPickGame } from "../../../../graphql/helpers/isQuickPickGame";
import { isWordopolisGame } from "../../../../graphql/helpers/isWordopolisGame";
import { useStep } from "../../../../contexts/step/StepContext";

import styles from "./AttributesNumberErrorModal.module.scss";

export const AttributesNumberErrorModal = () => {
  const { gamesToConfigure, setCurrentStep } = useStep();
  const { t } = useTranslation("project");
  const onClose = () => setCurrentStep(3, gamesToConfigure[0]);

  const generateErrorMessage = (game: Game) => {
    const configuration = game.configuration;
    const isWordopolis = isWordopolisGame(game);

    const gameConfigurationMap = {
      QuickRankConfiguration: { gameKind: isQuickPickGame(game) ? "QuickPick" : "QuickRank", minAttributes: 2 },
      RankifierConfiguration: {
        gameKind: "Rankifier",
        minAttributes: (configuration as RankifierConfiguration).cardsPerHand,
      },
      SwiperConfiguration: { gameKind: "Swiper", minAttributes: 2 },
      WordopolisConfiguration: { gameKind: "Wordopolis", minAttributes: 1 },
      TriviaConfiguration: { gameKind: "Trivia", minAttributes: 1 },
      WordleConfiguration: { gameKind: "Wordle", minAttributes: 1 },
    };

    const gameName = (
      <button onClick={() => setCurrentStep(3, game)} className={styles.errorImportant}>
        {game.name}
      </button>
    );

    const { gameKind, minAttributes } = gameConfigurationMap[configuration.__typename || "WordopolisConfiguration"];

    return (
      <>
        {gameName}{" "}
        {t(`gameSettings.attributesNumberErrorModal.error.${isWordopolis ? "word" : "card"}`, {
          gameKind,
          count: minAttributes,
        })}
      </>
    );
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <div className={styles.overlay} />
      <Dialog.Panel>
        <div className={styles.modal}>
          <Header variant="h5">{t("gameSettings.attributesNumberErrorModal.title")}</Header>
          <Paragraph>{t("gameSettings.attributesNumberErrorModal.description")}</Paragraph>
          <ul className={styles.errorsList}>
            {gamesToConfigure.map((game) => (
              <li key={game.id} className={styles.error}>
                <Paragraph size="small">{generateErrorMessage(game)}</Paragraph>
              </li>
            ))}
          </ul>

          <div className={styles.buttons}>
            <Button onClick={onClose}>{t("common:continue")}</Button>
          </div>
        </div>
      </Dialog.Panel>
    </Dialog>
  );
};
